// Campus photo for /colleges/university-of-illinois-chicago: CC BY-SA 4.0, by Sea Cow, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUIC_Quad_4-1-22.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-illinois-chicago/; credited under the photo.
const photo = {
    "slug": "university-of-illinois-chicago",
    "alt": "Aerial view of the quad and University Hall on the University of Illinois Chicago east campus",
    "src": "/colleges/university-of-illinois-chicago/campus-1600.webp",
    "srcSmall": "/colleges/university-of-illinois-chicago/campus-800.webp",
    "srcMid": "/colleges/university-of-illinois-chicago/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-illinois-chicago/og.jpg",
    "title": "UIC Quad 4-1-22",
    "author": "Sea Cow",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUIC_Quad_4-1-22.jpg",
    "read": "2026-10-02"
};

export default photo;
